<template>
  <div class="siteplan page">
    <div class="layout-container">
      <!-- <img src="/img/siteplan.jpg" alt="Siteplan"> -->
      <iframe src="https://sxsw.joeyai.tv/siteplan/" frameborder="0" style="width:1980px; height: 980px;"></iframe>
      <!-- <div class="legend">
        <img src="/img/legend.png" alt="">
      </div> -->
      <!-- <div id="overlay-container" @click="closeAll($event)">
        <div class="block-button" data-block-num="1" data-position-left='631' data-position-top='30'>
        </div>
        <div class="block-button" data-block-num="2" data-position-left='765' data-position-top='165'>
        </div>
        <div class="block-button" data-block-num="3" data-position-left='863' data-position-top='277'>
        </div>
        <div class="block-button" data-block-num="5" data-position-left='313' data-position-top='197'>
        </div>
        <div class="block-button" data-block-num="10" data-position-left='1238' data-position-top='381'>
        </div>
        <div class="block-button" data-block-num="11" data-position-left='1373' data-position-top='205'>
        </div>
      </div> -->

    </div>
    <transition enter-active-class="animated fadeIn" 
                leave-active-class="animated fadeOut">
      <div id="popup" v-show="showPopup" :key="key" mode="out-in">
        <div class="title">{{currentBlock.title}}</div>
        <div class="image-content"><img src="/img/popup-image.jpg" alt=""></div>
        <div class="content ">
          <div class="pure-g home" v-for="(home, index) in currentBlock.data" :key="home.name + home.sqft + index">
            <div class="pure-u-10-24">
              {{home.name}}
            </div>
            <div class="pure-u-8-24">
              {{home.sqft}} SQ.FT.
            </div>
            <div class="pure-u-6-24">
              {{home.beds}} BED
            </div>
          </div>
          <div class="btn-cotainer">
            <div @click="gotoFloorplan($event)" to="/floorplans" class="model-button" :data-town="currentBlock.town">view
              models</div>
          </div>
        </div>
        
      </div>
    </transition>
  </div>
</template>

<script>
  import Blocks from '../blocks.js';

  export default {
    data() {
      return {
        buttons: "",
        Blocks,
        currentBlock: "",
        showPopup: false,
        key: ""
      }
    },
    mounted() {
      this.buttons = document.querySelectorAll("#overlay-container .block-button");
      this.setPosition();
      this.setupClick();
      //console.log("blcoks", this.Blocks);
    }, //mounted

    methods: {
      setPosition() {
        this.buttons.forEach(elem => {
          let posLeft = elem.dataset.positionLeft;
          let posTop = elem.dataset.positionTop;
          elem.style.left = posLeft + 'px';
          elem.style.top = posTop + 'px';
        });
      },

      setupClick() {
        this.buttons.forEach(elem => {
          elem.addEventListener('click', e => {
            //console.log("e", e);
            e.stopPropagation();
            this.showInfo(e.target);
          });
        });
      },

      showInfo(elem) {
        let blockNum = elem.dataset.blockNum;
        this.key = blockNum;
        this.currentBlock = this.Blocks['block ' + blockNum];

        this.buttons.forEach(elem => {
          let num = elem.dataset.blockNum;
          if (num === blockNum) {
            elem.classList.add("selected");
          } else {
            elem.classList.remove("selected");
          }
        });
        this.showPopup = true;
        //document.querySelector("#popup").style.display = "block";

      },

      gotoFloorplan($e) {

        this.townToShow = $e.target.dataset.town;
        this.$router.push({
          path: 'floorplans',
          query: {
            townname: $e.target.dataset.town
          }
        });
      },

      closeAll($e) {
        console.log("closeall", $e);
        //$e.preventDefault();
        //document.querySelector("#popup").style.display = "none";
        this.showPopup = false;
        this.buttons.forEach(elem => {
          elem.classList.remove("selected");
        });
      }

    }, //methods

    beforeRouteLeave(to, from, next) {
      // ...
      /* document.querySelector("#popup").style.display = "none";
      this.buttons.forEach(elem => {
        elem.classList.remove("selected");
      }); */
      this.closeAll();
      next();
    },

  }
</script>

<style lang="scss" scoped>
  .page {
    padding: 0;
  }

  .layout-container {
    width: 100%;
    height: 100%;
    position: relative;

    img.siteplan-image {
      display: block;
      width: 100%;
      height: 100%;

    }

  }

  .legend {
    position: absolute;
    right: 30px;
    bottom: 30px;
  }

  #overlay-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: transparent;

    .block-button {
      position: absolute;
      left: 30px;
      top: 30px;
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background: white url(/img/plus-blue.png) no-repeat center center;
      z-index: 2;

      &.selected {
        background: #0071CE url(/img/cross-white.png) no-repeat center center;
      }
    }
  }

  #popup {
    /* display: none; */
    position: absolute;
    top: 36px;
    left: 695px;
    max-width: 480px;
    width: 100%;
    z-index: 2;

    .title {
      background: #0071CE;
      color: white;
      text-transform: uppercase;
      font-size: 26px;
      font-family: 'EngraversGothicW01-Bold';
      padding: 20px 15px;
    }

    .image-content {
      img {
        width: 100%;
        display: block;
      }
    }

    .content {
      padding: 22px 40px 22px 30px;
      align-content: flex-start;
      text-transform: uppercase;
      font-size: 20px;
      background: white;

      .home {
        justify-content: space-between;
        text-align: left;
        padding: 10px 0;

        color: black;

        >div:nth-child(3n+1) {
          color: #0071CE;
        }

        >div:nth-child(2) {
          text-align: center;
        }

        >div:last-child {
          text-align: right;
        }
      }

      .btn-cotainer {
        padding-top: 35px;

        .model-button {
          font-family: 'EngraversGothicW01-Bold';
          font-size: 20px;
          text-transform: uppercase;
          background: #0071CE;
          color: white;
          display: inline-block;
          width: auto;
          margin: 0 auto;
          padding: 15px 20px;
        }
      }
    }
  }
</style>